import { z } from "zod";
import { PersonId } from "../Investment/types";
import { DateSchema } from "../Types";
export const OCRDocumentUrlSchema = z.string().brand("OCRDocumentUrl");
export const OCRDocumentIdSchema = z
    .string()
    .startsWith("OCRD_")
    .regex(/^OCRD_[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}$/)
    .brand("OCRDocumentId");
export const DocumentProcessingStatusSchema = z.enum(["processing"]);
export const DocumentProcessingOcrSchema = z.object({
    documentId: OCRDocumentIdSchema,
    status: DocumentProcessingStatusSchema,
    personId: PersonId,
    vendor: z.string(),
    fileUploadId: z.string(),
    externalId: z.string(),
    createdAt: DateSchema,
    updatedAt: DateSchema,
});
export const BucketNamesSchema = z.enum([
    "docs.farther.com",
    "uat-docs.farther.com",
]);
/** Schema for document processing request body */
export const DocumentProcessRequestSchema = z.object({
    /** Array of S3 document URLs to process */
    documents: z.array(OCRDocumentUrlSchema),
    /** Document ID with format OCRD_XXXX-XXXX-XXXX */
    documentId: OCRDocumentIdSchema,
    bucket: BucketNamesSchema,
});
export const DocumentProcessResponseSchema = z.object({
    processingOcrDocuments: z.array(DocumentProcessingOcrSchema),
});
export const DocumentErrorResponseSchema = z.object({
    message: z.string(),
    details: z.string(),
});
//# sourceMappingURL=schemas.js.map